export function isWidgetMode() {
  return window.location.pathname.includes('/widgets');
}
